import React from "react";
import { Box, Link, Typography } from "@mui/material";
import WidgetFrame from "./WidgetFrame";
import DefinitionList from "./DefinitionList";

/** The status chip's colours by `state` — the widget's tokens only. */
export const STATUS_SX = {
	info: { background: "var(--w-surface)", color: "var(--w-text)", borderColor: "var(--w-accent)" },
	ok: { background: "var(--w-success-bg)", color: "var(--w-success-color)", borderColor: "var(--w-success-color)" },
	warn: { background: "var(--w-warning-bg)", color: "var(--w-warning-color)", borderColor: "var(--w-warning-color)" },
	error: { background: "var(--w-surface)", color: "var(--w-error)", borderColor: "var(--w-error)" },
};

/**
 * `summary` (spec-widget-mcp 05 Step 8): display-only — a title, an optional status chip coloured by
 * `state`, the items as a definition list and an optional link. NO control is focusable except the
 * link, which opens in a new tab with `noopener noreferrer` (AC-17).
 */
export default function SummaryCard({ envelope }) {
	const p = envelope.payload || {};
	const status = p.status && p.status.label ? p.status : null;
	return (
		<WidgetFrame kind="summary" title={p.title}>
			{status && (
				<Box
					component="span"
					data-status={status.state}
					sx={{ alignSelf: "flex-start", fontSize: 11.5, borderRadius: "999px", border: "1px solid", px: 1, py: 0.25, ...(STATUS_SX[status.state] || STATUS_SX.info) }}
				>
					{status.label}
				</Box>
			)}
			<DefinitionList items={p.items} />
			{p.link && p.link.href && (
				<Typography component="p" sx={{ fontSize: 12 }}>
					<Link href={p.link.href} target="_blank" rel="noopener noreferrer" sx={{ color: "var(--w-text)", textDecorationColor: "var(--w-accent)" }}>
						{p.link.label || p.link.href}
					</Link>
				</Typography>
			)}
		</WidgetFrame>
	);
}
